<template>
    <div>
        <p class="is-italic has-text-info clarity-mask">
            {{
                translate("audit_logs.template.verificationStatusChanged", false, [
                    context.eventRegistrationId,
                    context.competitorFirstName,
                    context.competitorLastName,
                    context.competitorAcademy,
                ])
            }}
        </p>
        <p>
            {{ translate("common.category") }}: <span class="has-text-weight-bold">{{ context.categoryName }}</span>
        </p>
        <p>
            <VerificationStatus :verification-state="context.previousStatus" />
            <span class="icon has-text-grey-light mx-1">
                <i class="fas fa-arrow-right"></i>
            </span>
            <VerificationStatus :verification-state="context.newStatus" />
        </p>
    </div>
</template>

<script setup lang="ts">
    import { VerificationStatusChanged } from "../../Api/auditLogsApi";
    import { translate } from "../../Common/translations";
    import { User } from "../../Common/types";
    import VerificationStatus from "../../CompetitorsVerification/VerificationStatus.vue";

    const props = defineProps<{
        context: VerificationStatusChanged;
        user: User;
    }>();
</script>

<style scoped></style>
